import { QueryClient } from '@tanstack/react-query';

import { IotMessage, MessageEventType } from "./iot-message"
import { ResourceType } from '../types';

const handleUpdate = (iotMessage: IotMessage, queryClient: QueryClient) => {

  const cacheKey = iotMessage.resourceType;

  switch (iotMessage.eventType) {
    case MessageEventType.Created:
      console.log(`~~ivai - ${cacheKey}`, iotMessage.eventType);
      queryClient.invalidateQueries({
        queryKey: [cacheKey],
        refetchType: "all",
      });
      break;
    case MessageEventType.Updated:
      console.log(`~~ivai - ${cacheKey}`, iotMessage.eventType);
      invalidateQueries(queryClient, iotMessage.resourceType, iotMessage.resourceIds)
      break;
    case MessageEventType.Deleted:
      console.log(`~~ivai - ${cacheKey}`, iotMessage.eventType);
      queryClient.invalidateQueries({
        queryKey: [cacheKey],
        refetchType: "all",
      });
      break;
    default:
      console.warn(`~~ivai - Not handled ${cacheKey} update`, iotMessage);
  }
}

export const invalidateQueries = (queryClient: QueryClient, resourceType: string, queryKey: string[]) => {
  for (const key of queryKey) {
    queryClient.invalidateQueries({
      predicate: (query) => {
        if (!Array.isArray(query.queryKey)) {
          return false
        }

        if (query.queryKey.length < 2) {
          return false
        }

        if (query.queryKey[0] != resourceType) {
          return false
        }

        if (!Array.isArray(query.queryKey[1])) {
          return query.queryKey[1] === key
        }

        return query.queryKey[1].some((id: string) => queryKey.includes(id));
      },
    });
  }
}

export const handleIotMessage = (topicName: string, payload: string, userId: string, queryClient: QueryClient): void => {
  const iotMessage: IotMessage = JSON.parse(payload);

  if (!iotMessage.resourceType) {
    console.warn(`~~ivai - Invalid message ${topicName}`, iotMessage);
    return;
  }

  if (!iotMessage.updateSender) {
    if (iotMessage?.sender === userId) {
      console.log(`~~ivai - Ignoring own message`, iotMessage.resourceType);
      return;
    }
  }

  if (iotMessage.resourceType === ResourceType.Chime) {
    handleUpdate({
      ...iotMessage,
      resourceType: ResourceType.Meeting,
    }, queryClient);
    return
  }

  handleUpdate(iotMessage, queryClient);
}